
import InfiniteLogoSlider from "../../Common/InfiniteLogoSlider";
import logoGoogle from "../../../img/logo_google.svg";
import logoFlipkart from "../../../img/logo-flipkart.svg";
import logoAdobe from "../../../img/logo-adobe.svg";
import logoMicrosoft from "../../../img/logo-microsoft.svg";
import logoAmazon from "../../../img/logo-amazon.svg";
import logoWalmart from "../../../img/logo-walmart.svg";
import logoPaytm from "../../../img/logo-paytm.svg";
import logoOracle from "../../../img/logo-oracle.svg";

const companyLogos = [
  { name: "Google", src: logoGoogle },
  { name: "Flipkart", src: logoFlipkart },
  { name: "Adobe", src: logoAdobe },
  { name: "Microsoft", src: logoMicrosoft },
  { name: "Amazon", src: logoAmazon },
  { name: "Walmart", src: logoWalmart },
  { name: "Paytm", src: logoPaytm },
  { name: "Oracle", src: logoOracle },
];


export default function StudentPlacements() {
  const logosToShow = [...companyLogos, ...companyLogos, ...companyLogos];

  return (
    <div className="bg-white py-5">
      <h2 className="font-[Gilroy-Bold] text-center font-normal text-sm leading-5 tracking-[0.02em] md:text-[20px] sm:font-gilroy-semibold mb-3 text-[#000000] sm:block hidden">
        1000+ alumni placed at:
      </h2>
      <h2 className="text-[14px] leading-6 font-gilroy-bold text-center sm:hidden block">
        1000+ alumni placed at:
      </h2>
      <InfiniteLogoSlider logos={logosToShow} speed={150}/>
    </div>
  );
}
